import { makeStyles } from '@material-ui/core';
const drawerWidth = 280;
export default makeStyles((theme) => ({
  // Desktop Links
  dashLeftContent: {
    flexDirection: 'column',
    height: '100%',
    padding: 0,
    alignItems: 'baseline',
  },
  linksInfo: {
    height: 'calc(100% - 110px - 130px)',
    overflow: 'hidden overlay',
    width: '100%',
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
      backgroundColor: '#1EA59A',
      width: '0.6em',
      visibility: 'hidden',
    },
    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
      borderRadius: 8,
      backgroundColor: theme.palette.warning.main,
      minHeight: 24,
      border: '1px solid #1EA59A',
      visibility: 'hidden',
    },
    '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
      backgroundColor: '#2B2B2B',
    },
    '@media (max-width: 1024px)': {
      height: 'calc(100% - 60px - 80px)',
    },
    '@media (max-height: 640px)': {
      height: 'calc(100% - 100px - 80px)',
    },
  },
  leftLinks: {
    flexGrow: 1,
    // padding: '0px 24px',
    '@media (max-width: 1220px)': {
      // padding: '0px 14px',
    },
  },
  menuItem: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontSize: 16,
    marginBottom: 25,
    color: theme.palette.error.contrastText,
    padding: '5px 40px',
    '& .MuiSvgIcon-root': {
      marginRight: 15,
      color: theme.palette.error.contrastText,
    },
    '@media (max-width: 1024px)': {
      padding: '10px 30px',
      marginTop: 2,
    },
    '@media (max-height: 640px)': {
      marginTop: 0,
    },
  },
  activeMenuItem: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.secondary.main,
    borderLeft: '6px solid',
    borderRadius: 2,
    marginBottom: 25,
    padding: '5px 33px',
    '& .MuiSvgIcon-root': {
      marginRight: 15,
    },
    // paddingLeft: 0,
    '@media (max-width: 1024px)': {
      padding: '10px 25px',
      // marginTop: 2,
    },
  },
  /// Logo Image
  dashLogo: {
    display: 'flex',
    width: '100%',
    marginBottom: 70,
    paddingLeft: 35,
    paddingTop: 44,
    '@media (max-width: 1220px)': {
      // paddingLeft: 20,
      // paddingTop: 30,
    },
    '@media (max-width: 1024px)': {
      marginBottom: 0,
      padding: 0,
    },
    '@media (max-height: 640px)': {
      // marginBottom: 40,
    },
  },
  logoImg: {
    width: 132,
    height: 'auto',
    '@media (max-width: 1024px)': {
      width: 115,
    },
  },
  /// Logout button
  leftBottomSection: {
    width: '100%',
    overflow: 'hidden overlay',
    '@media (max-height: 640px)': {
      height: 100,
    },
  },
  logoutBtn: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.error.contrastText,
    marginTop: 30,
    padding: '6px 16px',
    '@media (max-width: 1024px)': {
      padding: '10px 30px',
      marginTop: 15,
    },
    '@media (max-height: 640px)': {
      marginTop: 30,
    },
  },
  /// User Info
  dashAvatarLogo: {
    marginBottom: 60,
    padding: '0 40px',
    '@media (max-width: 1220px)': {
      padding: '0px 30px',
    },
    '@media (max-width: 1024px)': {
      padding: '30px 30px 0',
      marginBottom: 35,
    },
    '@media (max-height: 640px)': {
      marginBottom: 25,
    },
  },
  labelFundUpHead: {
    fontSize: 16,
  },
  labelStartUpText: {
    fontSize: 13,
    color: theme.palette.grey[600],
  },
  iconStyleOne: {
    height: 45,
    width: 45,
    fontSize: 25,
    fontWeight: 600,
    marginBottom: 10,
    textTransform: 'capitalize',
  },
  /// Mobile links
  menuDash: {
    marginRight: 20,
    alignSelf: 'center',
  },
  toolbarBox: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    alignItems: 'baseline',
    // '@media (max-width: 1024px)': {
    //   padding: 0,
    //   minHeight: 40,
    // },
    '@media (max-width: 1024px)': {
      padding: '15px 5%',
      minHeight: 40,
    },
  },
  drawer: {
    '& .MuiDrawer-paper': {
      overflow: 'unset',
    },
  },
  drawerContent: {
    width: drawerWidth,
    height: '100%',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 10px',
    height: 60,
  },
  rightIcon: {
    color: theme.palette.secondary.main,
    fontSize: 30,
  },
  brageAccount: {
    left: 40,
    top: 1,
    '& .MuiBadge-colorSecondary': {
      background: theme.palette.secondary.light,
      color: theme.palette.primary.contrastText,
    },
  },
  protifoImg: {
    marginRight: 15,
  },
}));
